export default function Gallery() {
  const images = [
    {
      src: "/test2.jpeg",
      label: "Grand Wedding"
    },
    {
      src: "/DSC02352.jpg",
      label: "Haldi Ceremony"
    },
    {
      src: "/test3.jpeg",
      label: "Reception Evening"
    },
    {
    src: "/SK_05720.jpg",
      label: "W Ceremony"
    },
    {
      src: "https://png.pngtree.com/thumb_back/fh260/background/20250923/pngtree-birthday-arch-decorated-with-gradient-balloons-and-happy-sign-for-festive-image_19531338.webp",
      label: "Birthday Tablescape"
    }
  ];

  return (
    <section id="gallery">
      <div className="gallery-header reveal">
        <div className="sec-label">Our Work</div>
        <h2 className="sec-title">
          Stories we've <em>crafted.</em>
        </h2>
      </div>

      <div className="gallery-grid">
        {images.map((img, i) => (
          <div key={i} className="gallery-item">
            <img src={img.src} alt={img.label} loading="lazy" />
            <div className="gallery-item-overlay">
              <span>{img.label}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}